module.exports = __webpack_public_path__ + "img/swipe1.b1d16e66.png";